
import { Mixins, Component, Watch } from 'vue-property-decorator';
import {
  Card,
  Col,
  Button,
  Row,
  Tooltip,
  Tabs,
  TabPane,
} from 'element-ui';
import api from '@/api/user';
import { tSearch } from '@/components/Search/index';
import noData from '@/components/noData/index.vue';
import BsMixin from '@/views/Home/mixins/bsMixin';
import bData from './components/data.vue';
import SearchForm from './components/searchForm.vue';
import pageMixin from '../../../mixins/pageMixin';

  @Component({
    components: {
      Card,
      Col,
      Button,
      Row,
      Tooltip,
      Tabs,
      TabPane,
      tSearch,
      noData,
      bData,
      SearchForm,
    },
  })

export default class cardList extends Mixins(BsMixin, pageMixin) {
  private otherProject: any = [];

  private searchData: any = [
    {
      value: 1,
      label: '全部',
    },
    {
      value: 2,
      label: '已拉黑',
    },
  ]

  private loading: boolean = false;

  private loadingMore: boolean = false;

  private timer: any = '';

  private searchString: string = '';

  private activeName: string = '';

  private worksTypeList: any = []

  mounted() {
    this.page.pageSize = 18;
    // 获取课程作品类型并获取作品数据
    api.getWorksType().then((res :any) => {
      this.worksTypeList = res.map((el: any) => ({ label: `${el.label}作品`, value: el.value }));
      this.activeName = res[0].value;
      this.getData(this.activeName);
    });
  }

  /**
   * @author niuhong
   * @desc 切换课程作品事件
   */
  handleClick(tab: any) {
    this.getData(tab.name, '', true);
  }

  /**
   * @author niuhong
   * @desc 搜索改获取数据事件
   */
  handleSearchChange(val: string) {
    this.searchString = val;
    this.getData(this.activeName, val, true);
  }

  // handleActivateChange(active: boolean) {
  //   if (active) {
  //     this.saveStatus = this.casValue;
  //     this.casValue = '';
  //   } else {
  //     this.casValue = this.saveStatus;
  //   }
  // }

  private projectStatus: string = ''

  handleAdvancedSearch() {
    // @ts-ignore
    const form: any = this.$refs.searchForm.getFormData();
    this.projectStatus = form.status ? form.status[0] : '';
    const title = form.title ? form.title : this.searchString;
    this.getData(this.activeName, title, true);
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    // @ts-ignore
    this.$refs.searchForm.handleClear();
    this.projectStatus = '1'; // 查询所有作品
    this.getData(this.activeName, '', true);
  }

  /**
  * @author niuhong
  * @desc 滚动加载事件
  */
  getScrollData() {
    if (this.otherProject.length === (this.page.total || 0)) return;
    this.loadingMore = true;
    this.timer = setTimeout(() => {
      this.page.pageNo += 1;
      if (this.searchString !== '') {
        this.getData(this.activeName, this.searchString);
      } else {
        this.getData(this.activeName);
      }
    }, 300);
  }

  bModalSure() {
    this.getData(this.activeName, '', true);
  }

  getData(courseType: string, title: string = '', refresh: boolean = false) {
    if (this.loadingMore !== true) {
      this.loading = true;
    }
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo };
    api.getOtherProject(data, this.$route.params.pid, courseType, title, this.projectStatus)
      .then((res: any) => {
        if (refresh) {
          this.otherProject = []
          this.page.pageNo = 1;
          this.page.total = 0;
        }
        this.loadingMore = false;
        this.otherProject.push(...res.content);
        clearTimeout(this.timer);
        this.page.total = res.totalElements;
        this.loading = false;
      });
  }
}
